import React, { useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import OutstandingFollowUps from "./OutstandingFollowUps";
import PenaltyFollowUps from "./PenaltyFollowUps";
import "./Followups.css";

const Followups = () => {
  const [activeTab, setActiveTab] = useState("outstanding");

  return (
    <div className="followups-layout">
      <Sidebar />

      <div className="followups-main">
        <div className="followups-header">
          <Header />
        </div>

        <main className="followups-content">
          <div className="followups-tabs-wrapper">
            <div className="followups-tabs">

              <button
                type="button"
                className={`followups-tab ${
                  activeTab === "outstanding" ? "active" : ""
                }`}
                onClick={() => setActiveTab("outstanding")}
              >
                Outstanding Follow-ups
              </button>

              <button
                type="button"
                className={`followups-tab ${
                  activeTab === "penalty" ? "active" : ""
                }`}
                onClick={() => setActiveTab("penalty")}
              >
                Penalty Follow-ups
              </button>

            </div>
          </div>

          <div className="followups-module-content">

            {activeTab === "outstanding" && (
              <OutstandingFollowUps embedded />
            )}

            {activeTab === "penalty" && (
              <PenaltyFollowUps embedded />
            )}

          </div>
        </main>
      </div>
    </div>
  );
};

export default Followups;